// Minimal client-side JWT helpers for reading display claims and expiry from
// the acquired token. Tokens are only decoded for display/expiry, never trusted
// for authorization (the backend validates tokens).

export function decodeJwtPayload(jwt: string): Record<string, unknown> | null {
  try {
    const part = jwt.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(part)) as Record<string, unknown>;
  } catch {
    return null;
  }
}

/** Best-effort sign-in name/email for display, across work and personal accounts. */
export function getUsernameFromToken(jwt: string): string | undefined {
  const claims = decodeJwtPayload(jwt);
  if (!claims) {
    return undefined;
  }
  const candidates = ["preferred_username", "upn", "unique_name", "email", "name"] as const;
  for (const key of candidates) {
    const value = claims[key];
    if (typeof value === "string" && value) {
      return value;
    }
  }
  return undefined;
}
